const listeners = new Set<() => void>();

export const requestPlaidLink = () => {
  listeners.forEach((listener) => listener());
};

export const onPlaidLinkRequest = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
